module.exports = __webpack_public_path__ + "img/team-chat.02fd41ee.svg";